import { InputAdornmentProps, InputAdornment as MuiInputAdornment } from "@mui/material";

type Props = InputAdornmentProps;

export const InputAdornment = ({ children, ...props }: Props) => {
  return <MuiInputAdornment {...props}>{children}</MuiInputAdornment>;
};
